import React from 'react';
import { SdgProject } from '../../types';
import SdgTile from './SdgTile';

type SdgItemProps = {
  sdgProject: SdgProject;
  mainFocusText?: string;
};

const SdgItem = ({
  sdgProject: {
    budget,
    details_link: detailsLink,
    duration,
    pictureSdg,
    region,
    sdg_focus: sdgFocus,
    sector,
    title,
  },
  mainFocusText = '',
}: SdgItemProps): JSX.Element => {
  return (
    <>
      <div className="sdg-content">
        <div className="sdg-image-wrapper">
            <img className="sdg-title-image" src={pictureSdg.pictureUrl} alt={pictureSdg.altText}/>
        </div>
        <div className="sdg-content-wrapper">
          <div className="sdg-content--field">
            {sector ? <span dangerouslySetInnerHTML={{__html:sector}}/> : ''}
          </div>
          <div className="sdg-content--headline">
            <h3 className="hl-4" dangerouslySetInnerHTML={{__html:title}}/>
          </div>
          <div id="sdg-tile">
            <SdgTile {...{region, budget, duration, sdgFocus, mainFocusText }} />
          </div>
        </div>
      </div>
      <div className="sdg-content">
        <div className="sdg-button-wrapper">
          <div dangerouslySetInnerHTML={{__html:detailsLink}}/>
        </div>
      </div>
    </>
  )
};

export default SdgItem;
